(function () {
  'use strict';

  function buildStarsHtml(averageTenths) {
    var tenths = Math.max(0, Math.min(50, parseInt(averageTenths, 10) || 0));
    var full = Math.floor(tenths / 10);
    var remainder = tenths % 10;
    var hasHalf = false;

    if (remainder >= 3 && remainder <= 7) {
      hasHalf = true;
    } else if (remainder > 7) {
      full += 1;
    }

    if (full > 5) { full = 5; hasHalf = false; }
    if (full === 5) hasHalf = false;

    var halfAt = full + 1;
    var html = '';

    for (var i = 1; i <= 5; i++) {
      if (i <= full) {
        html += '<span class="product-rating__star is-full" aria-hidden="true">★</span>';
      } else if (hasHalf && i === halfAt) {
        html += '<span class="product-rating__star is-half" aria-hidden="true">★</span>';
      } else {
        html += '<span class="product-rating__star" aria-hidden="true">★</span>';
      }
    }
    return html;
  }

  function mountProductRating() {
    var mount = document.querySelector('[data-product-rating-mount]');
    var jsonEl = document.getElementById('ProductReviewStats');
    if (!mount || !jsonEl) return;

    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    if (!data.count || data.count < 1) return;

    var tenths = data.averageTenths;
    if (tenths == null && data.average != null) {
      tenths = Math.round(parseFloat(data.average, 10) * 10);
    }

    var stars = buildStarsHtml(tenths);

    mount.innerHTML =
      '<div class="product-rating product-page__rating-inner" role="img" aria-label="' +
      data.average + ' av 5, ' + data.count + ' recensioner">' +
      '<span class="product-rating__stars" aria-hidden="true">' + stars + '</span>' +
      '<span class="product-rating__average">' + data.average + '</span>' +
      '<span class="product-rating__count">(' + data.count + ')</span>' +
      '</div>';
  }

  mountProductRating();

  function initQuantityStepper(root) {
    var stepper = (root || document).querySelector('[data-quantity-stepper]');
    if (!stepper) return;

    var input = stepper.querySelector('[data-quantity-input]');
    var display = stepper.querySelector('[data-quantity-display]');
    var minus = stepper.querySelector('[data-qty-minus]');
    var plus = stepper.querySelector('[data-qty-plus]');
    if (!input || !display || !minus || !plus) return;

    function getQty() { return Math.max(1, parseInt(input.value, 10) || 1); }
    function setQty(value) {
      var qty = Math.max(1, value);
      input.value = String(qty);
      display.textContent = String(qty);
      minus.disabled = qty <= 1;
    }

    minus.addEventListener('click', function () { setQty(getQty() - 1); });
    plus.addEventListener('click', function () { setQty(getQty() + 1); });
    setQty(1);
  }

  initQuantityStepper();

  /* Gallery thumbnails */
  var gallery = document.querySelector('[data-product-gallery]');
  if (gallery) {
    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function (e) {
        e.stopPropagation();
        var id = thumb.getAttribute('data-gallery-thumb');
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        slides.forEach(function (slide) {
          var active = slide.getAttribute('data-media-id') === id;
          slide.classList.toggle('is-active', active);
        });
      });
    });
  }

  /* Variantval: uppdaterar pris, variant-id och köpknapp vid byte */
  function initVariantSelection() {
    var picker = document.querySelector('[data-variant-picker]');
    var variantsEl = document.querySelector('[data-product-variants]');
    if (!picker || !variantsEl) return;

    var variants;
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var idInput = document.querySelector('[data-variant-id]');
    var atcBtn = document.querySelector('[data-add-to-cart]');
    var atcText = document.querySelector('[data-add-to-cart-text]');
    var mainPriceEl = document.querySelector('.product-page__price[data-product-price]');

    var addLabel = atcText ? atcText.textContent.trim() : 'Lägg i varukorgen';
    var soldOutLabel = 'Slutsåld';

    // Härleder valutaformatet från det redan renderade priset (t.ex. "49 kr")
    function detectMoneyTemplate(text) {
      var m = text && text.match(/\d[\d\s.,]*\d|\d/);
      if (!m) return { prefix: '', suffix: ' kr', hasDecimals: false };
      var num = m[0];
      var idx = text.indexOf(num);
      return {
        prefix: text.slice(0, idx),
        suffix: text.slice(idx + num.length),
        hasDecimals: /[.,]\d{2}\s*$/.test(num)
      };
    }

    function formatCents(cents, tpl) {
      var amount = (parseInt(cents, 10) || 0) / 100;
      var numStr;
      if (tpl.hasDecimals) {
        numStr = amount.toFixed(2).replace('.', ',');
      } else {
        numStr = String(Math.round(amount));
      }
      var parts = numStr.split(',');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      numStr = parts.join(',');
      return tpl.prefix + numStr + tpl.suffix;
    }

    var tpl = detectMoneyTemplate(mainPriceEl ? mainPriceEl.textContent.trim() : '');

    function getSelected() {
      var groups = picker.querySelectorAll('[data-option-index]');
      var selected = [];
      groups.forEach(function (group) {
        var i = parseInt(group.getAttribute('data-option-index'), 10);
        var checked = group.querySelector('input[data-option-input]:checked');
        selected[i] = checked ? checked.value : null;
      });
      return selected;
    }

    function findVariant(selected) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (!v.options || v.options.length !== selected.length) continue;
        var ok = true;
        for (var j = 0; j < v.options.length; j++) {
          if (v.options[j] !== selected[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function updateSelectedClasses() {
      picker.querySelectorAll('input[data-option-input]').forEach(function (inp) {
        var label = inp.closest('label');
        if (label) label.classList.toggle('is-selected', inp.checked);
      });
    }

    function applyVariant(variant) {
      updateSelectedClasses();

      if (!variant) {
        if (atcBtn) atcBtn.disabled = true;
        if (atcText) atcText.textContent = soldOutLabel;
        return;
      }

      if (idInput) idInput.value = variant.id;

      var priceStr = formatCents(variant.price, tpl);
      if (mainPriceEl) mainPriceEl.textContent = priceStr;
      document.querySelectorAll('[data-price]').forEach(function (el) {
        el.textContent = priceStr;
      });

      var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      document.querySelectorAll('[data-compare-price]').forEach(function (el) {
        if (hasCompare) { el.textContent = formatCents(variant.compare_at_price, tpl); el.hidden = false; }
        else { el.hidden = true; }
      });

      if (atcBtn && atcText) {
        if (variant.available) { atcBtn.disabled = false; atcText.textContent = addLabel; }
        else { atcBtn.disabled = true; atcText.textContent = soldOutLabel; }
      }
    }

    picker.addEventListener('change', function (e) {
      if (!e.target || !e.target.matches('[data-option-input]')) return;
      applyVariant(findVariant(getSelected()));
    });

    // Synka direkt vid laddning
    applyVariant(findVariant(getSelected()));
  }

  initVariantSelection();
})();
